module.exports = __webpack_public_path__ + "static/icons/icon-map--spain-7bb5843fb5ffbcab0128e0128867a713.svg";